module.exports = __webpack_public_path__ + "static/img/28.e8d134b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moho/28.png
// module id = 8vpo
// module chunks = 0